export default function Footer() {
  return (
    <footer
      className="border-t border-black/10 mt-32 py-16 px-6 md:px-12 lg:px-24"
      data-testid="site-footer"
    >
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
        <div className="max-w-md">
          <h3 className="font-serif text-3xl font-light leading-none">Truth</h3>
          <p className="mt-3 text-sm text-black/60 leading-relaxed">
            A slow, public record of one person learning to look at what is.
            New entries when there is something worth saying.
          </p>
        </div>
        <div className="text-[11px] uppercase tracking-[0.22em] text-black/45">
          © {new Date().getFullYear()} — written by hand
        </div>
      </div>
    </footer>
  );
}
